var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "374.999991pt",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 84.1875 L 337.5 84.1875 L 337.5 291.1875 L 37.5 291.1875 Z M 37.5 84.1875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509277%,17.248535%,24.308777%)",
      fillOpacity: 1
    },
    d: "M 61.980469 375 L 313.019531 375 C 347.195312 375 375 347.195312 375 313.019531 L 375 61.980469 C 375 27.804688 347.195312 0 313.019531 0 L 61.980469 0 C 27.804688 0 0 27.804688 0 61.980469 L 0 313.019531 C 0 347.195312 27.804688 375 61.980469 375 Z M 61.980469 375 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 329.78125 96.359375 C 329.625 96.15625 329.464844 95.960938 329.277344 95.773438 C 329.273438 95.769531 329.269531 95.765625 329.265625 95.761719 C 323.128906 88.703125 314.097656 84.226562 304.039062 84.226562 L 70.960938 84.226562 C 60.894531 84.226562 51.859375 88.710938 45.71875 95.78125 C 45.542969 95.957031 45.386719 96.148438 45.234375 96.339844 C 40.410156 102.152344 37.5 109.617188 37.5 117.746094 L 37.5 257.703125 C 37.5 276.1875 52.511719 291.222656 70.960938 291.222656 L 304.042969 291.222656 C 322.492188 291.222656 337.5 276.1875 337.5 257.703125 L 337.5 117.75 C 337.5 109.625 334.597656 102.167969 329.78125 96.359375 Z M 325.933594 117.75 L 325.933594 257.703125 C 325.933594 260.324219 325.46875 262.839844 324.621094 265.175781 L 245.824219 187.574219 L 324.15625 109.101562 C 325.296875 111.757812 325.933594 114.679688 325.933594 117.75 Z M 70.960938 279.632812 C 65.742188 279.632812 60.945312 277.792969 57.179688 274.726562 L 137.359375 195.769531 L 168.160156 226.628906 C 173.324219 231.804688 180.195312 234.65625 187.5 234.65625 C 194.804688 234.65625 201.675781 231.804688 206.839844 226.628906 L 237.640625 195.769531 L 317.820312 274.726562 C 314.054688 277.792969 309.257812 279.632812 304.039062 279.632812 Z M 49.066406 257.703125 L 49.066406 117.75 C 49.066406 114.679688 49.703125 111.757812 50.84375 109.101562 L 129.175781 187.574219 L 50.378906 265.175781 C 49.53125 262.839844 49.066406 260.324219 49.066406 257.703125 Z M 304.039062 95.816406 C 308.832031 95.816406 313.269531 97.375 316.878906 100 L 198.660156 218.433594 C 195.679688 221.421875 191.714844 223.066406 187.5 223.066406 C 183.28125 223.066406 179.320312 221.421875 176.339844 218.433594 L 58.121094 100 C 61.730469 97.375 66.167969 95.816406 70.960938 95.816406 Z M 304.039062 95.816406 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6587560ba74d28d14f3ebac3bb98b797.svg";
export { ForwardRef as ReactComponent };